var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 1h24v18H-2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#B82121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.938 13.937h-2.25a1.125 1.125 0 0 1-1.126-1.125V7.187c0-.622.504-1.125 1.125-1.125h14.626c.62 0 1.125.503 1.125 1.125v5.625c0 .621-.504 1.125-1.125 1.125h-2.25M3.813 8.312h1.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.938 10.562h10.125v7.875H4.938zM15.063 6.062H4.937V2.687c0-.622.504-1.125 1.125-1.125h7.875c.622 0 1.126.503 1.126 1.125v3.375zM7.188 12.812h5.625M7.188 15.062h3.937"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.6c522673.svg";
export { ForwardRef as ReactComponent };